import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { LoginRequestSchema, LoginResponseSchema, RefreshResponseSchema } from '../schemas/auth.js';

export const auth = {
  login: endpoint('POST', '/auth/login', LoginRequestSchema, LoginResponseSchema, 'include'),
  refresh: endpoint('POST', '/auth/refresh', z.object({}), RefreshResponseSchema, 'include'),
  logout: endpoint(
    'POST',
    '/auth/logout',
    z.object({}),
    z.object({ message: z.string() }),
    'include',
  ),
};
